import { lazy } from 'react'
import SuppliersLoader from './loader'

export default {
  Suppliers: {
    Component: lazy(() => import('./Suppliers.Page')),
    Loader: SuppliersLoader,
  },
}
